import {MvsCoreService} from "../../../../../../../core/shared/service/mvs-core.service";
import {MvsCrudService} from "../../../../../../../core/shared/service/crud/mvs-crud.service";
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {
    CommentHistoryEnum,
    TicketHistoryComponent
} from "../../../ticket-comment-history/ticket-comment-history.component";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {DtoDetail} from "../../../../../../../core/shared/dto/dto.detail";
import {UploadDocumentEventInterface} from "../../../../../../../core/shared/dto/upload-document-event.interface";
import {DmDocumentAssignmentEuService} from "../../../../../../dm/service/api/dm-document-assignment-eu.service";
import {TicketCommentDto} from "../../../../../model/dto/entity/ticket-comment.dto";
import {DmDocumentAssignmentEuDto} from "../../../../../../dm/model/dto/entity/dm-document-assignment-eu.dto";
import {DmDocumentAssignmentTypeEnum} from "../../../../../../dm/enum/dm-document-assignment-type-enum.enum";
import {finalize, forkJoin} from "rxjs";

@Component({
    selector: 'tm-ticket-comment-history',
    templateUrl: './tm-ticket-comment-history.component.html',
    standalone: false
})
export class TmTicketCommentHistoryComponent implements OnInit, OnChanges, OnDestroy {

    ticketCommentService: MvsCrudService;
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    actions: any[] | undefined;
    selectedAction: CommentHistoryEnum = 1;
    toggle: boolean;

    uploadDocumentEvent: UploadDocumentEventInterface[] = [];

    @Input() processMode: boolean = false;
    @Input() euVisible: boolean = false;
    @Input() objectIdentifier: ObjectIdentifier;
    @Input() ticketTypeDto: DtoDetail;
    @Input() objectTypeId: number;
    @Input() documentTypeId: number;
    @Input() highlightCommentId: number;
    @Output() onCommentChange: EventEmitter<string> = new EventEmitter();


    @ViewChild(TicketHistoryComponent) ticketCommentHistory: TicketHistoryComponent;

    constructor(
        protected coreService: MvsCoreService,
         protected documentAssignmentEuService: DmDocumentAssignmentEuService) {
        this.ticketCommentService = this.coreService.getCrudService("tm.TicketComment");

    }

    ngOnInit(): void {
        this.initComponent();
        this.refreshComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        if (this.processMode == true) {
            this.toggle = true;
        }
        this.loadActions();

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    loadActions() {
        this.actions = [
            {label:'Alles',name: CommentHistoryEnum[CommentHistoryEnum["All Activity"]], code: CommentHistoryEnum["All Activity"]},
            {label:'Kommentare',name: CommentHistoryEnum[CommentHistoryEnum.Comment], code: CommentHistoryEnum.Comment},
            {label:'Aktionen',name: CommentHistoryEnum[CommentHistoryEnum.History], code: CommentHistoryEnum.History},
        ];
    }

    /**
     * refresh ticket comments
     */
    refreshHistory(ticketComment: TicketCommentDto | any) {
        if (ticketComment.euVisible) {
            this.assignDocumentToEuTicket();
        } else {
            this.uploadDocumentEvent = [];
        }

        this.ticketCommentHistory.refreshHistory();
    }

    assignDocumentToEuTicket() {
        // prevent duplicate submissions
        if (this.busy || !this.uploadDocumentEvent?.length) {
            return;
        }

        this.busy = true;

        // Map each upload event to an HTTP observable
        const assignments = this.uploadDocumentEvent.map(uploadDoc => {
            const dto = new DmDocumentAssignmentEuDto();
            dto.documentDtoId = uploadDoc.documentId;
            dto.objectTypeDtoId = uploadDoc.objectIdentifier.objectType as any;
            dto.objectId = uploadDoc.objectIdentifier.objectId;
            dto.documentAssignmentType = DmDocumentAssignmentTypeEnum.primary;

            return this.documentAssignmentEuService.create(dto);
        });

        // Run all calls in parallel, wait until all complete
        forkJoin(assignments)
            .pipe(finalize(() => (this.busy = false))) // ensures busy resets even on error
            .subscribe({
                next: (results) => {
                    // all succeeded
                    console.log('Assignments created:', results);
                    this.uploadDocumentEvent = []; // clear once done
                },
                error: (err) => {
                    // error handling
                    console.error('Error assigning documents', err);
                },
            });
    }

    handleCommentChange(event: string) {
        this.onCommentChange.emit(event)
    }

    handleDocumentUpload(event: UploadDocumentEventInterface) {
        this.uploadDocumentEvent.push(event);
    }


    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        this.refreshComponent();
    }


    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

}
